import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorField", "textField"]

  connect() {
    this.syncFields()
  }

  updateFromColor() {
    this.textFieldTarget.value = this.colorFieldTarget.value
  }

  updateFromText() {
    const color = this.textFieldTarget.value
    if (this.isValidColor(color)) {
      this.colorFieldTarget.value = color
    }
  }

  syncFields() {
    const textValue = this.textFieldTarget.value
    if (textValue && this.isValidColor(textValue)) {
      this.colorFieldTarget.value = textValue
    } else if (this.colorFieldTarget.value) {
      this.textFieldTarget.value = this.colorFieldTarget.value
    }
  }

  isValidColor(color) {
    return /^#[0-9A-F]{6}$/i.test(color)
  }
}